export default __webpack_public_path__ + "static/9692copy-887151516c60928ca9212b82c45a6e41.jpg";